<template>
  <dtunes-modal v-if="!success">
    <template v-slot:button>
      <v-icon>mdi-plus</v-icon>
      Add Admin
    </template>
    <template v-slot:content>
      <v-card class="pad-10">
        <v-card-title class="d-flex justify-center">
          <p class="text-center">
            <b>Add Admin to <br />{{ team.name }}</b>
          </p>
        </v-card-title>
        <v-card-text>
          <v-select
            v-model="adminType"
            :items="Admins"
            item-text="email"
            item-value="id"
            :rules="formRules"
            :menu-props="{ maxHeight: '200' }"
            color="orange"
            label="Select Admin"
            outlined
          >
          </v-select>
          <br />
          <p class="text-center" v-if="adminType !== ''">
            ** You are about to add {{ user }} to {{ team.name }} **
          </p>
          <default-button @click="addToTeam" :loading="loading" :disabled="!isComplete"
            >Add to Team</default-button
          >
        </v-card-text>
      </v-card>
    </template>
  </dtunes-modal>
</template>

<script>
import DtunesModal from "@/components/dtunes-modal.vue";
import DefaultButton from "@/components/Buttons/default-button.vue";
import { AdminService, TeamService } from "@/services";
import app from '@/main';

export default {
  data: () => ({
    adminType: "",
    success: false,
    loading:false,
    Admins: [],
    formRules: [(v) => !!v || "This field is required"],
    value: "",
    user: '',
  }),
  props: {
    team: {
      type: Object,
    },
  },
  components: {
    DtunesModal,
    DefaultButton,
  },
  computed: {
    isComplete() {
      return this.adminType;
    },
  },
  methods: {
    async getAdmins() {
      const data = await AdminService.getAdmins();
      this.Admins = data;
    },
      async addToTeam(){
        this.loading = true;
        TeamService.addToTeam({
          admin: this.adminType,
          department : this.team.id
        }).then(()=>{
          this.success = true;
          this.loading = false;
          app.$store.dispatch('toast', {
          message: 'Admin added successfully',
          variant: 'success'
        })
          setTimeout(()=>{ this.success = false;},100);
          this.$emit("add-member");
      
        })
      }
  },
  mounted() {
    this.getAdmins();
  },
  watch: {
    adminType(newval, oldval) {
      if (newval) {
        let admin = this.Admins.find((item) => item.id == this.adminType);
        this.user = admin.email
      }
      console.log(oldval);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>